/**
 * PremiumBirthDatePicker
 * Simple wrapper around PremiumBirthDateTimePicker for date-only usage
 * Maintains backward compatibility with existing imports
 */

import React from 'react';
import PremiumBirthDateTimePicker from './PremiumBirthDateTimePicker';

const PremiumBirthDatePicker = ({ 
  value, 
  onChange, 
  label = 'Doğum Tarihi',
  required = false,
  testId = 'premium-birth-date'
}) => {
  return (
    <PremiumBirthDateTimePicker
      dateValue={value}
      onDateChange={onChange}
      dateLabel={label}
      dateRequired={required}
      dateTestId={testId}
      showTimePicker={false}
      showUnknownTimeOption={false}
    />
  );
};

export default PremiumBirthDatePicker;
